<template>
  <div class="game-tag-tab">
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="page"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
    >
      <template #table-header>
        <div>
          <el-button type="primary" size="mini" @click="handleAddTag">新增</el-button>
          <el-button type="primary" size="mini" @click="handleRefresh">刷新</el-button>
        </div>
      </template>

      <template #colImageUrl="{ row }">
        <el-image
          v-if="row.image_url"
          :src="row.image_url"
          fit="cover"
          :preview-src-list="[row.image_url]"
          style="width: 36px; height: 36px; border-radius: 4px"
        />
        <span v-else>无图标</span>
      </template>
      <template #colHasGameCount="{ row }">
        <el-button type="text" size="small" @click="handleRelateGames(row)">{{ row.has_game_count }}</el-button>
      </template>
      <template #colStatus="{ row }">
        <el-switch
          v-model="row.status"
          :active-value="1"
          :inactive-value="2"
          @change="handleStatusChange(row.id, row.status)"
        />
      </template>
      <template #colActions="{ row }">
        <el-button type="text" size="small" @click="handleRelateGameList(row)">关联游戏</el-button>
        <el-button type="text" size="small" @click="handleEditTag(row)">编辑</el-button>
        <el-button type="text" size="small" class="danger-button" danger @click="handleDeleteTag(row)">删除</el-button>
      </template>
    </SchemaTablePage>

    <ManageGameTagDialog :visible.sync="tagDialogVisible" :tag-data="currentTag" @save-success="handleTagSaveSuccess" />

    <ManageGameTagRelationDialog
      :visible.sync="relationDialogVisible"
      :tag-data="currentTag"
      @save-success="handleRelationSaveSuccess"
    />

    <ManageGameTagBatchRelateGameDialog
      :visible.sync="batchRelateDialogVisible"
      :tag-data="currentTag"
      @save-success="handleBatchRelateSaveSuccess"
    />
  </div>
</template>

<script>
import { changeGameCategoryStatus, deleteGameCategory, listGameCategory } from '@/api/gameManage/gameTag.js'
import ManageGameTagDialog from './ManageGameTagDialog.vue'
import ManageGameTagRelationDialog from './ManageGameTagRelationDialog.vue'
import ManageGameTagBatchRelateGameDialog from './ManageGameTagBatchRelateGameDialog.vue'
import SchemaTablePage from '@/components/SchemaTablePage'

export default {
  name: 'ManageGameTagTab',
  components: {
    ManageGameTagDialog,
    ManageGameTagRelationDialog,
    ManageGameTagBatchRelateGameDialog,
    SchemaTablePage,
  },
  data() {
    return {
      searchSchema: [],
      defaultQuery: {},
      tableColumns: [
        { prop: 'sort', label: '排序', width: 68, align: 'center', resizable: false },
        { prop: 'title', label: '标签名称', minWidth: 240, resizable: false },
        { prop: 'image_url', label: '标签图标', minWidth: 140, align: 'center', resizable: false, slot: 'colImageUrl' },
        { prop: 'has_game_count', label: '已关联游戏', minWidth: 100, resizable: false, slot: 'colHasGameCount' },
        { prop: 'status', label: '状态', minWidth: 100, align: 'center', resizable: false, slot: 'colStatus' },
        { prop: 'action', label: '操作', width: 180, align: 'center', resizable: false, slot: 'colActions' },
      ],
      tagDialogVisible: false,
      relationDialogVisible: false,
      batchRelateDialogVisible: false,
      currentTag: null,
    }
  },
  methods: {
    request(params) {
      return listGameCategory(params)
    },
    buildParams({ page, limit }) {
      return {
        page,
        page_size: limit,
      }
    },
    parseResult(response) {
      if (!response || response.code !== 0) {
        if (response && response.code !== 0) {
          this.$message.error('加载游戏标签列表失败：' + (response.msg || '未知错误'))
        }
        return { list: [], total: 0 }
      }
      return {
        list: response.data.list || [],
        total: response.data.total != null ? response.data.total : 0,
      }
    },
    reloadTable() {
      this.$refs.tablePageRef?.reload?.()
    },
    handleAddTag() {
      this.currentTag = null
      this.tagDialogVisible = true
    },
    handleRefresh() {
      this.reloadTable()
    },
    handleEditTag(tag) {
      this.currentTag = { ...tag }
      this.tagDialogVisible = true
    },
    async handleDeleteTag(tag) {
      if (tag.has_game_count > 0) {
        this.$message.warning('该标签下还存在游戏，请移除关联游戏后再试')
        return
      }
      const id = tag.id
      this.$confirm('确定要删除该游戏标签吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          try {
            const response = await deleteGameCategory({ id })
            if (response.code === 0) {
              this.$message.success('删除成功')
              this.reloadTable()
            } else {
              this.$message.error('删除失败：' + (response.msg || '未知错误'))
            }
          } catch (error) {
            this.$message.error('删除失败：' + error.message)
          }
        })
        .catch(() => {})
    },
    async handleStatusChange(id, status) {
      try {
        const response = await changeGameCategoryStatus({ id, status })
        if (response.code === 0) {
          this.$message.success('状态更新成功')
        } else {
          this.$message.error('状态更新失败：' + (response.msg || '未知错误'))
          this.reloadTable()
        }
      } catch (error) {
        this.$message.error('状态更新失败：' + error.message)
        this.reloadTable()
      }
    },
    handleRelateGames(tag) {
      this.currentTag = { ...tag }
      this.relationDialogVisible = true
    },
    handleRelateGameList(tag) {
      this.currentTag = { ...tag }
      this.batchRelateDialogVisible = true
    },
    handleTagSaveSuccess() {
      this.tagDialogVisible = false
      this.reloadTable()
    },
    handleRelationSaveSuccess() {
      this.relationDialogVisible = false
      this.reloadTable()
    },
    handleBatchRelateSaveSuccess() {
      this.batchRelateDialogVisible = false
      this.reloadTable()
    },
  },
}
</script>

<style scoped>
.actions {
  margin-bottom: 12px;
}

.game-tag-tab :deep(.el-table__body-wrapper) {
  max-height: 75vh;
  overflow-y: auto;
}
</style>
